import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import Pagination from '../Pagination'
import CityList from './CityList'
import CityEdit from './CityEdit'
import CityAdd from './CityAdd'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import helpers from '../../utils/helpers'
import OSearch from 'components/reusable/OSearch'

const CityManager = () => {
  const { t } = useTranslation()
  const { user, updatePageName } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'city_manager') ?? {}
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [cityAdd, setCityAdd] = useState(false)
  const [cityEdit, setCityEdit] = useState(false)
  const [currentItem, setCurrentItem] = useState('')
  const [cityView, setCurrentView] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const [cityList, setCityList] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handleEdit = item => {
    setCurrentItem(item)
    setCityEdit(!cityEdit)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleView = item => {
    setCurrentItem(item)
    setCurrentView(!cityView)
  }

  const handleCategory = () => {
    setCityAdd(!cityAdd)
  }

  const allCity = async data => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      if (
        (data?.deletePage && cityList?.length >= 1) ||
        (isFilter && category && data?.statusChange && cityList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }
      const payload = {
        page,
        pageSize,
        status: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.cityList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setCityList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all city list==>>>>', error.message)
    }
  }
  useEffect(() => {
    updatePageName(t('CITY_MANAGER'))
  }, [])

  useEffect(() => {
    allCity()
  }, [page, filterData, sort])

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  const handleReset = () => {
    setFilterData({
      category: '',
      searchKey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='py-4 px-3 '>
          <div className='bg-white rounded-lg border border-[#E9EDF9] '>
            <form className='border-b 2xl:flex gap-2 px-4 py-3 border-b-[#E3E3E3] '>
              <div className='flex flex-wrap col-span-2 items-center mb-2 2xl:mb-0'>
                <div className='flex lg:pt-0 pt-3 flex-wrap items-center'>
                  <div className='items-center mb-3 relative flex '>
                    <OSearch
                      placeholder={t('SEARCH_BY_COUNTRY_CITY')}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    setIsReset={setFilterData}
                    isReset={filterData?.isReset}
                  />
                  <OButton
                    onClick={handleReset}
                    extraClasses='ml-3 mb-3'
                    label='Reset'
                    type='button'
                    style={{ borderRadius: '0.5rem' }}
                  />
                </div>
              </div>

              <div className='justify-end px-4 ms-auto flex items-center  mb-3'>
                {(manager?.add || user?.role === 'admin') && (
                  <button
                    className='bg-LightBlue rounded-lg items-center border flex text-sm px-8 ml-3 py-2 border-transparent text-white hover:bg-DarkBlue whitespace-nowrap'
                    onClick={() => handleCategory()}
                    title='Add city'
                    type='button'
                  >
                    + {t('ADD_CITY')}
                  </button>
                )}
              </div>
            </form>
            <CityList
              cityList={cityList}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
              allCity={allCity}
              handleEdit={handleEdit}
              handleView={handleView}
              currentItem={currentItem}
              cityView={cityView}
            />
            {cityEdit && (
              <CityEdit
                allCity={allCity}
                handleEdit={handleEdit}
                currentItem={currentItem}
                CityList={CityList}
              />
            )}

            {cityAdd && (
              <CityAdd
                cityAdd={cityAdd}
                allCity={allCity}
                handleCategory={handleCategory}
                cityList={cityList}
              />
            )}
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </>
  )
}

export default CityManager
